import React from "react";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

export default function ProviderSubscriptionPage() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Subscription</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Review provider subscription state, current plan visibility, and future billing management.
        </p>
      </section>

      <section style={cardStyle}>
        <div style={{ display: "grid", gap: "0.7rem", color: "#334155" }}>
          <div><strong>Current plan:</strong> Starter</div>
          <div><strong>Status:</strong> Active</div>
          <div><strong>Billing cycle:</strong> Monthly</div>
          <div><strong>Renewal date:</strong> Not configured yet</div>
          <div><strong>Notes:</strong> Upgrade controls can be wired later.</div>
        </div>
      </section>
    </div>
  );
}